// Parse the dates
const parseCustomDate = (dateString) => {
  if (!dateString) return new Date(NaN);
  // Split the string into year, month, day, hour, minute, second.
  const parts = dateString.split(/[\s:-]/).map(Number);
  // Creates a Date object in the LOCAL time zone of the machine running the script.
  // Month is 0-indexed (0=Jan, 11=Dec), so we subtract 1 from the month part.
  return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
};

// Check meeting status and render function
export const checkMeetingStatus = (meetingsData, containerEl) => {

  const now = new Date();
  const container = document.querySelector(containerEl);
  container.innerHTML = "";

  let meetingsFound = false;
  let maxMeetingsCount = 6;
  let meetingsRendered = 0;
  
  // Time formatting options for 24-hour clock
  const timeFormatOptions = { hour: "2-digit", minute: "2-digit", hour12: false };

  // Loop through our meetings to determine the status of the meeting
  meetingsData.forEach((meeting) => {

    // ensure we have valid start and end times in order to test against
    const startTime = parseCustomDate(meeting.start);
    const endTime = parseCustomDate(meeting.end);

    // if we don't, error out
    if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
      console.error("Skipping meeting due to invalid date parsing:", meeting.clientName, meeting.start);
      return;
    }

    // 1. Filter out meetings that have already ended.
    if (now >= endTime) {
      return;
    }
    // 2. Stop processing if we've reached the max count.
    if (meetingsRendered >= maxMeetingsCount) {
      return;
    }

    meetingsFound = true;
    meetingsRendered++;

    let statusText;
    let statusClass;

    // Determine the status of the meetings

    // Check for "In Progress"
    if (now >= startTime && now < endTime) {
      statusText = "In Progress";
      statusClass = "text-green-500";
    } else {
      // Check for "Upcoming" 
      const oneHourBeforeStart = new Date(startTime.getTime() - 60 * 60 * 1000); 
      if (now >= oneHourBeforeStart) {
        // If we are within an hour of the meeting start time
        const msUntilStart = startTime.getTime() - now.getTime();
        const totalSecondsUntilStart = Math.ceil(msUntilStart / 1000);
        const minutesUntilStart = Math.floor(totalSecondsUntilStart / 60);
        if (minutesUntilStart <= 0) {
            statusText = "Starting now";
        } else {
            statusText = `Starting in ${minutesUntilStart} mins`;
        }
        statusClass = "text-amber-500";
      } else {
        // If we are greater than an hour away
        statusText = `Upcoming`;
        statusClass = "text-blue-500";
      }
    }

      // If the meeting has an "All Day" flag
      if(meeting.isAllDay == 'Yes'){
        statusText = `All Day`;
        statusClass = "text-black";
      }

    // Render list
    const meetingDiv = document.createElement("div");
    let meetingDivOutput;
     meetingDivOutput = `
        <div class="flex flex-row items-center justify-between gap-4 w-full bg-white shadow rounded-lg p-5">
            <img class="h-20 self-start w-auto aspect-square rounded-full object-cover" src="${meeting.logoUrl}" alt="${meeting.clientName} logo" loading="lazy" />
            <div class="flex-grow">
                <h2 class="leading-none mb-1.5 tracking-tight font-bold text-[2vw]">${meeting.clientName}</h2>`;
                meetingDivOutput += `<p class="leading-none tracking-tight font-normal text-[1.75vw] text-black/50">
                ${meeting.title.substring(0,36)}${meeting.title.length > 36 ? "..." : ""}`;
                if(meeting.isAllDay !== 'Yes'){ meetingDivOutput += ` | ${startTime.toLocaleTimeString([], timeFormatOptions)} - ${endTime.toLocaleTimeString([], timeFormatOptions)}`; }
                meetingDivOutput += `</p></div>
            <div class="ml-auto text-right"><p class="text-[2vw] font-bold pr-4 ${statusClass}">${statusText}</p></div></div>`;
    meetingDiv.innerHTML = meetingDivOutput;
    container.appendChild(meetingDiv);
  });

  // If we have no meetings, show the video, else show the list
  if (meetingsFound) {
    container.classList.remove("opacity-0");
    document.getElementById('video').classList.add("opacity-0");
  } else {
    container.classList.add("opacity-0");
    document.getElementById('video').classList.remove("opacity-0");
  }

};